import { render } from "./ContactEmpty.vue?vue&type=template&id=3a8d03bc&scoped=true"
import script from "./ContactEmpty.vue?vue&type=script&lang=js"
export * from "./ContactEmpty.vue?vue&type=script&lang=js"

import "./ContactEmpty.vue?vue&type=style&index=0&id=3a8d03bc&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8d03bc"]])

export default __exports__